import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/header'
import Footer from '../components/footer'

const TemplateWrapper = ({ children }) => (
  <div
    style={{
      background: '#102027',
    }}
  >
    <Helmet
      title="Gigantoid"
      meta={[
        { name: 'description', content: 'Gigantoid: web consulting' },
        { name: 'keywords', content: 'web consulting' },
      ]}
    />
    <Header />
    <div
      style={{
        color: '#8bc34a',
        height: '80vh',
        margin: '0 auto',
        maxWidth: 960,
        padding: '0px 1.0875rem 1.45rem',
        paddingTop: 0,
      }}
    >
      {children()}
    </div>
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js